import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";

import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import Groups2RoundedIcon from "@mui/icons-material/Groups2Rounded";
import LightbulbRoundedIcon from "@mui/icons-material/LightbulbRounded";

import routes from "@constants/routes";

import { useTechnologyQuery } from "@queries/portfolio.query";

import { useUserStore } from "@store/userStore";

interface IUseTechnologyBreadcrumbs {
  isOrganization: boolean;
}

const usePortfolioBreadcrumbs = ({ isOrganization }: IUseTechnologyBreadcrumbs) => {
  const navigate = useNavigate();
  const { technologyId } = useParams();

  const { data: technology } = useTechnologyQuery(technologyId);
  const { organizationId } = useUserStore();

  const technologyName = technology?.name || "";

  const breadcrumbs = useMemo(
    () => [
      isOrganization
        ? {
            clickable: true,
            icon: Groups2RoundedIcon,
            label: "Organization",
            onClick: () => {
              navigate(routes.ORGANIZATION + "/" + organizationId);
            },
            tooltipText: "Browse all technologies in your Organization.",
          }
        : {
            clickable: true,
            icon: BusinessCenterIcon,
            label: "Portfolio",
            onClick: () => {
              navigate(routes.PORTFOLIO);
            },
            tooltipText: "Browse all technologies in your Portfolio.",
          },
      {
        clickable: false,
        icon: LightbulbRoundedIcon,
        label: technologyName,
        onClick: () => {
          /* Do Nothing */
        },
        tooltipText: `Browse companies, contacts, and campaigns saved to ${technologyName}`,
      },
    ],
    [navigate, isOrganization, technologyName, organizationId],
  );

  return {
    breadcrumbs,
  };
};

export default usePortfolioBreadcrumbs;
